import { skipToken, useQuery } from "@apollo/client/react";

import {
  LockedBalanceEntriesOrderBy,
  TokenMarketVolumeSummariesDocument,
} from "@/graphql/codegen/graphql";

type TokenMarketDataProps = {
  publicKey: string;
  ammPublicKey?: string | null;
  currentUserPublicKey?: string | null;
  enabled?: boolean;
};

export const useTokenMarketData = ({
  publicKey,
  ammPublicKey,
  currentUserPublicKey,
  enabled = true,
}: TokenMarketDataProps) => {
  const shouldQuery = Boolean(publicKey && ammPublicKey) && enabled;

  const { data, loading, refetch } = useQuery(
    TokenMarketVolumeSummariesDocument,
    shouldQuery
      ? {
          fetchPolicy: "network-only",
          variables: {
            marketVolumeFilter: {
              coin1Account: {
                publicKey: {
                  equalTo: publicKey,
                },
              },
              coin2Account: {
                publicKey: {
                  equalTo:
                    publicKey === process.env.NEXT_PUBLIC_FOCUS_APP_PUBLIC_KEY
                      ? process.env.NEXT_PUBLIC_DESO_ZERO_PUBLIC_KEY
                      : process.env.NEXT_PUBLIC_FOCUS_APP_PUBLIC_KEY,
                },
              },
            },
            founderBalanceFilter: {
              hodler: {
                publicKey: {
                  equalTo: publicKey,
                },
              },
            },
            ammBalanceFilter: {
              hodler: {
                publicKey: {
                  equalTo: ammPublicKey,
                },
              },
            },
            userBalanceFilter: {
              hodler: {
                publicKey: {
                  equalTo: currentUserPublicKey,
                },
              },
            },
            lockedBalancesFirst: 1,
            lockedBalancesOrderBy:
              LockedBalanceEntriesOrderBy.UnlockTimestampNanoSecsAsc,
            founderUnlockFilter: {
              hodlerAccount: {
                publicKey: {
                  equalTo: publicKey,
                },
              },
            },
          },
        }
      : skipToken,
  );

  return {
    data,
    loading,
    refetch,
  };
};
